import vTabs from './Tabs.vue';

export { vTabs };



// WEBPACK FOOTER //
// ./src/baseComponents/components/Tabs/index.js